// extracted by mini-css-extract-plugin
export var container = "ModalComponentStyle-module--container--1prBH";
export var appear = "ModalComponentStyle-module--appear--3AG7e";
export var overlay = "ModalComponentStyle-module--overlay--bZZii";